<template>
  <div class="localInfo">
    <LocalType
      class="localType"
      v-if="typeList.length > 0 && !isView"
      :locale="locale"
      :lang="lang"
      :list="typeList" />
      <div v-if="!$route.params.placeId" :style="{'height':'50px'}"></div>
    <p v-if="infoMain && localList.length === 0" class="noData notranslate">{{locale.localinfo_select}}</p>
    <LocalInfoHome v-if="infoMain && localList.length > 0"
      :locale="locale"
      :typeList="typeList"
      :all="localList"/>
    <router-view
      :list="list"
      :locale="locale"
      :lang="lang" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LocalType from '@/components/LocalInfo/LocalType.vue'
import LocalInfoHome from '@/components/LocalInfo/LocalInfoHome.vue'

export default {
  name: 'LocalInfo',
  props: [
    'locale',
    'lang'
  ],
  components: {
    LocalType,
    LocalInfoHome
  },
  computed: {
    ...mapGetters({
      localList: 'localinfo/getLocalList',
      types: 'localinfo/getLocalType'
    }),
    infoMain () {
      return this.$route.name === 'localinfo'
    },
    recommend () {
      return this.localList.filter(x => x.recommend)
    },
    typeList () {
      let types = this.types
      if (types.length > 0) {
        const filter = ['restaurant', 'cafe', 'park', 'tourist_attraction']
        for (let i = 0; i < filter.length; i++) {
          const tmp = filter[i]
          const idx = types.findIndex(x => x === tmp)
          if (idx >= 0) {
            types.splice(idx, 1)
            types.unshift(tmp)
          }
        }
      }
      types = this.recommend && this.recommend.length > 0 ? ['recommend'].concat(types) : types
      return types
    },
    list () {
      const type = this.$route.params.type
      const list = this.localList.filter(x => {
        if (type === 'recommend') {
          return x.recommend
        } else {
          return x.siteType === type
        }
      })
      return list
    },
    isView () {
      return !!this.$route.params.placeId && !!this.$route.params.type
    }
  },
  watch: {
    '$route' (to, from, next) {
      this.track()
    }
  },
  async mounted () {
    this.$store.commit('loading', true)
    await this.$store.dispatch('localinfo/getLocalList', 'all')
    await this.$store.dispatch('localinfo/getLocalInfoType')
    this.infoView()
    this.track()
    this.$store.commit('loading', false)
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      const params = this.$route.params
      const places = this.list
      const title = function () {
        let title = 'local information'
        if (params.type) {
          title += ` : ${params.type}`
        }
        if (params.placeId) {
          const placeName = places.find(x => x.placeId === params.placeId).name
          title += ` - ${placeName}`
        }
        return title
      }
      this.$gtag.pageview({
        page_path: path,
        page_title: title()
      })
    },
    // 타입 카테고리 없이 placeid만 갖고 접근할 때 type으로 들어오므로 params.type을 params.type + params.paceid 형태로 변경한다
    infoView () {
      const type = this.type
      const localList = this.localList
      const typeList = this.typeList
      const isView = !!type && !typeList.includes(type) && !!localList.find(x => x.placeId === type)
      if (isView) {
        const placeId = this.type
        const replaceType = localList.find(x => x.placeId === placeId).siteType
        if (!!replaceType) {
          this.$router.replace({
            name: 'localview',
            params: {
              type: replaceType,
              placeId: placeId
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.localType{
  position: fixed;
  top: 90px;
  left: 0;
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  z-index: 5;
  transition: all 0.5s;
  transition-delay: 0.5s;
}
.scrollDown .localType {
  top: 50px;
  transition-delay: 0.8s;
}
/*
.viewBox {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  z-index: 1;
}
*/
.notFound,
.noData {
  padding: 75px 30px 200px;
  text-align: center;
  font-size: 1.2em;
  &:before {
    content: "";
    display: block;
    height: 128px;
    margin-bottom: 15px;
    background: url('~@/assets/img/localinfo.png') 50% 50% / contain no-repeat;
  }
}
.notFound:before {
  background-image: url('~@/assets/img/localinfo_nodata.png');
}
@media screen and (min-width: 768px) {
  .localType {
    top: 0;
    left: 80px;
  }
  .scrollDown .localType {
    top: 0;
  }
}
@media screen and (min-width: 800px) {
  .localType {
    left: 180px;
  }
}
@media screen and (min-width: 1024px) {
  .localType {
    left: 240px;
  }
}
</style>
